import {useState} from 'react'
import {useIntl} from 'react-intl'
import SubmitButtonRow from './components/SubmitButtonRow'
import BulkDropzone from './components/BulkDropzone'
import HourOnlyInput from '../components/HourOnlyInput'
import {BULK_SPECIAL_TEMPLATE} from './core/_requests'
import SharedData from '../../common/SharedData'

const SpecialBulkCard = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = SharedData()
  const currentDate = new Date().toISOString().split('T')[0]

  const [bulkFile, setBulkFile] = useState<any>({
    value: null,
    error: false,
  })
  const [startDate, setStartDate] = useState<any>({
    value: '',
    error: false,
    msg: '',
  })
  const [endDate, setEndDate] = useState<any>({
    value: '',
    error: false,
    msg: '',
  })

  const handleDateChange = (e: {target: {id: string; value: string}}) => {
    const {id, value} = e.target
    if (id === 'date_start') {
      setStartDate({...startDate, value})
    } else {
      setEndDate({...endDate, value})
    }
  }

  return (
    <div className='adb-stack'>
      {/* Steps 1 & 2 — download template + upload bulk sheet */}
      <section className='adb-card'>
        <BulkDropzone
          id='file'
          hasError={bulkFile.error}
          setField={setBulkFile}
          templateUrl={BULK_SPECIAL_TEMPLATE}
          token={currentUser?.token}
          user={currentUser}
        />
      </section>

      {/* Step 3 — schedule */}
      <section className='adb-card adb-schedule'>
        <div className='adb-step'>
          <div className='adb-step-num'>3</div>
          <div className='adb-step-body'>
            <h2 className='adb-step-title'>
              {formatMessage({id: 'set_schedule_title'})} <sup className='text-danger'>*</sup>
            </h2>
            <p className='adb-step-desc'>{formatMessage({id: 'set_schedule_desc'})}</p>

            <div className='adb-grid'>
              <div className='adb-field'>
                <label className='adb-label adb-label--start'>
                  <i className='fas fa-calendar-check' aria-hidden='true' />
                  {formatMessage({id: 'start_date_time'})}
                </label>
                <HourOnlyInput
                  id='date_start'
                  value={startDate.value}
                  isRequired={true}
                  hasError={startDate.error}
                  onChange={handleDateChange}
                  errorMsg={startDate.msg || formatMessage({id: 'date_start_required'})}
                  min={currentDate}
                  showLabel={false}
                />
              </div>

              <div className='adb-field'>
                <label className='adb-label adb-label--end'>
                  <i className='fas fa-calendar-xmark' aria-hidden='true' />
                  {formatMessage({id: 'end_date_time'})}
                </label>
                <HourOnlyInput
                  id='date_end'
                  value={endDate.value}
                  isRequired={true}
                  hasError={endDate.error}
                  onChange={handleDateChange}
                  errorMsg={endDate.msg || formatMessage({id: 'date_end_required'})}
                  min={currentDate}
                  showLabel={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubmitButtonRow
        bulkFile={bulkFile}
        setBulkFile={setBulkFile}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </div>
  )
}

export default SpecialBulkCard
